import React from 'react';
import SvgIcon from './SvgIcon';

const Trash: React.FC<any> = ({ color, height, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width={height * 2}
    height={height * 2}
    viewBox="0 0 459 459"
    className={className}
  >
    <path
      d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5    H51v51h357V25.5z" // eslint-disable-line
      fill={color}
    />
  </SvgIcon>
);

export default Trash;
